import Current from "./Current";
import List from "./List";


export default {Current, List}